import { throttle } from 'throttle-debounce';
import { gsap } from 'gsap';

import {IS_TOUCH} from '../helpers/consts';

export default () => {
	if(IS_TOUCH) return;

	const blocks = document.querySelectorAll('.js-hover-label-block');

	let mousePos = {x: 0, y: 0};
	let isHovering = false;

	blocks.forEach(function(block) {
		const labelAttr = block.getAttribute('data-label');

		const item = document.querySelector('.js-hover-label-item[data-label="' + labelAttr + '"]');

		if(!item) return;

		let itemWidth = item.offsetWidth;
		let itemHeight = item.offsetHeight;

		block.addEventListener('mouseenter', function(e) {
			itemWidth = item.offsetWidth;
			itemHeight = item.offsetHeight;

			mousePos.x = e.pageX;
			mousePos.y = e.pageY;

			isHovering = true;

			gsap.to(item, {
				duration: 0.2,
				// scale: 0.9,
				autoAlpha: 0,
				onComplete: () => {
					if (isHovering) {
						gsap.to(item, {
							duration: 0.2,
							x: mousePos.x - window.innerWidth / 2 - itemWidth,
							y: mousePos.y - window.innerHeight / 2 ,
							// scale: 1,
							autoAlpha: 1,
						});
					}
				},
			});
		});

		block.addEventListener('mousemove', throttle(100, function(e) {
			mousePos.x = e.pageX;
			mousePos.y = e.pageY;

			gsap.to(item, {
				duration: 0.2,
				x: mousePos.x - window.innerWidth / 2 - itemWidth,
				y: mousePos.y - window.innerHeight / 2,
			});
		}));

		block.addEventListener('mouseleave', function() {
			isHovering = false;
			gsap.to(item, {
				duration: 0.2,
				// scale: 0.9,
				autoAlpha: 0,
			});
		});
	});

}
